import { cubicEaseOut } from '@helpers/animate';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h3 } from '@helpers/typography';
import DotPaginationStyles from '@stories/Components/Misc/DotPagination/DotPagination.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  @media ${until(Device.DesktopSmall)} {
    ${DotPaginationStyles.Container} {
      margin-top: 1rem;
      gap: 8px;
    }
  }

  @media ${from(Device.DesktopSmall)} {
    ${DotPaginationStyles.Container} {
      display: none;
    }
  }

  &[data-single-slide='true'] {
    @media ${from(Device.DesktopSmall)} {
      ${DotPaginationStyles.Container} {
        display: flex;
      }
    }
  }
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;
  text-align: center;
`;
const Title = styled.div `
  ${h3}
`;
const Content = styled.div `
  ${contentStyles}
  margin: 0 auto;
  max-width: 720px;
`;
const List = styled.ul `
  --itemGap: 32px;
  --itemWidth: 480px;

  display: flex;
  justify-content: flex-start;
  margin: 32px -12px 0;
  transition: transform 0.45s ${cubicEaseOut};

  @media ${from(Device.TabletLarge)} {
    margin: 32px -16px 0;
  }

  @media ${from(Device.DesktopSmall)} {
    justify-content: center;
    margin-top: 56px;
    transition: none;
  }

  [data-single-slide='true'] & {
    @media ${from(Device.DesktopSmall)} {
      justify-content: flex-start;
      margin: 32px -12px 0;
      transition: transform 0.45s ${cubicEaseOut};
    }
  }
`;
const Item = styled.li `
  display: grid;
  flex: 0 0 100%;
  padding: 0 12px;

  /* Required to ensure that overflowing elements are hidden on initial page load (for Google's Mobile Friendly test) */
  @media ${until(Device.MobileLarge)} {
    &[data-active-item='false'] {
      height: 0;
      overflow: hidden;
    }
  }

  @media ${from(Device.MobileLarge)} {
    max-width: min(512px, calc(288 / 375 * 100vw));
  }

  @media ${from(Device.TabletLarge)} {
    padding: 0 16px;
  }

  @media ${from(Device.DesktopSmall)} {
    flex: 1 1 calc(100% / var(--count));
  }

  [data-single-slide='true'] & {
    max-width: 100%;

    @media ${from(Device.DesktopSmall)} {
      flex: 1 0 100%;
    }
  }
`;
const CtaWrapper = styled.div `
  margin-top: 16px;

  @media ${from(Device.DesktopSmall)} {
    margin-top: 56px;
  }
`;
const LatestArticlesStyles = {
    Container,
    Content,
    CtaWrapper,
    Inner,
    Item,
    List,
    Title,
};
export default LatestArticlesStyles;
